import { FiTarget, FiCalendar } from 'react-icons/fi';
import { GoLocation } from 'react-icons/go';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

interface ContentProps {
  $hasMap: boolean;
}
export const Content: any = styled.div<ContentProps>`
  max-width: ${({ $hasMap }) => ($hasMap ? 'calc(100vw - 144px)' : 'auto')};
`;

Content.Title = styled.h6`
  color: ${ColorPalette.HEX.DimGray2};
  font-size: 12px;
  margin-bottom: 10px;
`;
export const Address: any = styled.ul``;

Address.Item = styled.li`
  text-transform: capitalize;
  color: ${ColorPalette.HEX.PineTree};
  font-size: 12px;
  margin-bottom: 8px;
  display: flex;
  align-items: flex-start;
  line-height: 1.2em;
  .icons {
    font-size: 12px;
  }
`;

Address.Icon = styled.span`
  width: 12px;
  height: 12px;
  margin-right: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

Address.Image = styled.span`
  width: 12px;
  height: 12px;
  margin-left: 10px;
  margin-right: 5px;
`;
export const StyledButton = styled(Button)`
  font-size: 14px;
  text-shadow: 0 1px 3px rgb(0 0 0 / 20%);
  padding: 0 8px;
  width: auto;
  height: 32px;
  border-radius: 8px;
`;

export const Map = styled.div`
  margin-left: 10px;
  width: 112px;
  height: 112px;
  border-radius: 8px;
  border: solid 1px ${ColorPalette.HEX.BrightGray6};
`;

export const Icon = styled.img`
  width: 14px;
  height: 14px;
  vertical-align: top;
`;

export const IconPickUp = styled(FiTarget)`
  color: ${ColorPalette.HEX.PineTree} !important;
`;
export const IconDropOff = styled(GoLocation)`
  color: ${ColorPalette.HEX.PineTree} !important;
`;
export const IconDate = styled(FiCalendar)`
  color: ${ColorPalette.HEX.PineTree} !important;
`;
